import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Directive, APP_INITIALIZER, Injector, LOCALE_ID } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { SettingsComponent } from './components/settings/settings.component';
import { MenuComponent } from './components/menu/menu.component';
import { LoginComponent } from './components/login/login.component';
import { HomeComponent } from './components/home/home.component';
import { InteractionQueueComponent } from './interactionQueue/interactionQueue.component';
import { AuthGuard } from './components/auth/auth.guard';
import { AuthService } from './components/auth/auth.service';
// import { jqxDockingComponent } from 'node_modules/jqwidgets-scripts/jqwidgets-ts/angular_jqxdocking';
// import { jqxBarGaugeComponent } from 'node_modules/jqwidgets-scripts/jqwidgets-ts/angular_jqxbargauge';
// import { jqxKnobComponent } from 'node_modules/jqwidgets-scripts/jqwidgets-ts/angular_jqxknob';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { JwtInterceptor } from './_helpers/jwt.interceptor';
import { MasterPageComponent } from './masterpage/masterpage.component';
import { RequestInterceptorService } from './_helpers/request-interceptor.service';
import { DataTablesModule } from 'angular-datatables';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { NgxLoadingModule } from 'ngx-loading';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { registerLocaleData } from '@angular/common';
import { BsDatepickerModule, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { SortableModule } from 'ngx-bootstrap/sortable';
import ptBr from '@angular/common/locales/pt';
registerLocaleData(ptBr);

// services
import { NotFoundComponent } from './not-found/not-found.component';
import { AuthenticationService } from './services/workflow/authentication.service';
import { FilterService } from './services/filter/filter.service';
import { ReportService } from './services/report/report.service';
import { AppSettingsService } from './services/app/appSettings.service';
import { ConfigurationService } from './services/configuration/configuration.service';
import { ExemplosComponent } from './exemplos/exemplos.component';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { ptBrLocale  } from 'ngx-bootstrap/locale';
import {BsModalRef, ModalModule} from 'ngx-bootstrap/modal';
import { ChartsModule } from 'ng2-charts';
import { IndicatorsComponent } from './indicators/indicators.component';
import { FiltersComponent } from './filters/filters.component';
import { ConfigGroupingComponent } from './configuration/grouping/config.grouping.component';
import { NonWorkingDaysComponent } from './configuration/non-working-days/non-working-days.component';
import { ConfigInteractionQueueComponent } from './configuration/interactionQueue/config.interactionQueue.component';
import { WeekDayPipe } from './pipes/weekDay.pipe';
import { GroupingComponent } from './grouping/grouping.component';
import { WorkingDaysComponent } from './working-days/working-days.component';
// import { SelectModule } from 'ng2-select';
import { GoalsComponent } from './configuration/goals/goals.component';
import { NgxMaskModule } from 'ngx-mask';
import { ApprovalChartComponent } from './configuration/approval-chart/approval-chart.component';
import { ApprovalChartResultComponent } from './approvalChartResult/approvalChartResult.component';
import {NgSelectModule} from '@ng-select/ng-select';


// noinspection TsLint
const routes: Routes = [
  { path: 'home', component: MasterPageComponent, children: [{ outlet: 'master', path: '', component: HomeComponent }]
    , canActivate: [AuthGuard], runGuardsAndResolvers: 'always'
  },
  { path: 'indicators', component: MasterPageComponent, children: [{ outlet: 'master', path: '', component: IndicatorsComponent }]
    , canActivate: [AuthGuard], runGuardsAndResolvers: 'always'
  },
  { path: 'interaction', component: MasterPageComponent, children: [{ outlet: 'master', path: '', component: InteractionQueueComponent }]
    , canActivate: [AuthGuard], runGuardsAndResolvers: 'always'
  },
  { path: 'app-config-grouping', component: MasterPageComponent, children: [{ outlet: 'master', path: '', component: ConfigGroupingComponent }]
    , canActivate: [AuthGuard], runGuardsAndResolvers: 'always'
  },
  { path: 'app-config-interaction-queue', component: MasterPageComponent, children: [{ outlet: 'master', path: '', component: ConfigInteractionQueueComponent }]
    , canActivate: [AuthGuard], runGuardsAndResolvers: 'always'
  },
  { path: 'app-non-working-days', component: MasterPageComponent, children: [{ outlet: 'master', path: '', component: NonWorkingDaysComponent }]
     , canActivate: [AuthGuard], runGuardsAndResolvers: 'always'
  },
  { path: 'app-working-days', component: MasterPageComponent, children: [{ outlet: 'master', path: '', component: WorkingDaysComponent }]
    , canActivate: [AuthGuard], runGuardsAndResolvers: 'always'
  },
  { path: 'app-goals', component: MasterPageComponent, children: [{ outlet: 'master', path: '', component: GoalsComponent }]
    , canActivate: [AuthGuard], runGuardsAndResolvers: 'always'
  },
  { path: 'exemplos', component: MasterPageComponent, children: [{ outlet: 'master', path: '', component: ExemplosComponent }]
    , canActivate: [AuthGuard], runGuardsAndResolvers: 'always'
  },
  { path: 'app-goals', component: MasterPageComponent, children: [{ outlet: 'master', path: '', component: GoalsComponent }]
    , canActivate: [AuthGuard], runGuardsAndResolvers: 'always'
  },
  { path: 'app-approval-chart', component: MasterPageComponent, children: [{ outlet: 'master', path: '', component: ApprovalChartComponent }]
    , canActivate: [AuthGuard], runGuardsAndResolvers: 'always'
  },
  { path: 'app-approval-chart-result', component: MasterPageComponent, children: [{ outlet: 'master', path: '', component: ApprovalChartResultComponent
  }]
    , canActivate: [AuthGuard], runGuardsAndResolvers: 'always'
  },

  { path: 'login', component: LoginComponent },
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: '**', component: NotFoundComponent }
];

defineLocale('pt-br', ptBrLocale );

const appInitializerFn = (appConfig: AppSettingsService) => {
  return () => {
    return appConfig.loadAppConfig();
  };
};

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    SettingsComponent,
    MenuComponent,
    LoginComponent,
    InteractionQueueComponent,
    HomeComponent,
    // jqxBarGaugeComponent,
    // jqxDockingComponent,
    // jqxKnobComponent,
    MasterPageComponent,
    NotFoundComponent,
    ExemplosComponent,
    IndicatorsComponent,
    FiltersComponent,
    ConfigGroupingComponent,
    NonWorkingDaysComponent,
    WeekDayPipe,
    GroupingComponent,
    WorkingDaysComponent,
    GoalsComponent,
    ConfigInteractionQueueComponent,
    ApprovalChartComponent,
    ApprovalChartResultComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', useHash: true }),
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' }),
    BsDatepickerModule.forRoot(),
    TypeaheadModule .forRoot(),
    TooltipModule.forRoot(),
    ChartsModule,
    DataTablesModule,
    ProgressbarModule.forRoot(),
    ModalModule.forRoot(),
    BrowserModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    NgxLoadingModule.forRoot({}),
    NgxDatatableModule,
    NgxMaskModule.forRoot(),
    TimepickerModule.forRoot(),
    NgSelectModule,
    SortableModule.forRoot()
  ],
  providers: [AuthGuard, AuthService,
    AppSettingsService,
    AuthenticationService, BsLocaleService,
    FilterService, ReportService, ConfigurationService, BsModalRef,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptorService, multi: true },
    { provide: LOCALE_ID, useValue: window.navigator.language }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
